import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import store from '../store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/promotioncodes',
    name: 'reductions',
    component: () =>
      import(/* webpackChunkName: "reductions" */ '../views/Reductions.vue'),
  },
  {
    path: '/referalcodes',
    name: 'referalcodes',
    component: () =>
      import(/* webpackChunkName: "reductions" */ '../views/Referals.vue'),
  },  {
    path: '/giftcards',
    name: 'giftcards',
    component: () =>
      import(/* webpackChunkName: "reductions" */ '../views/GiftCards.vue'),
  },
  {
    path: '/promotions',
    name: 'promotions',
    component: () =>
      import(/* webpackChunkName: "promotions" */ '../views/Promotions.vue'),
  },
  {
    path: '/bestellungen',
    name: 'orders',
    component: () =>
      import(/* webpackChunkName: "orders" */ '../views/Orders.vue'),
  },
  {
    path: '/angebote',
    name: 'offers',
    component: () =>
      import(/* webpackChunkName: "offers" */ '../views/Offers.vue'),
  },
  {
    path: '/statistik',
    name: 'statistik',
    component: () =>
      import(
        /* webpackChunkName: "offers" */ '../views/statistics/Overview.vue'
      ),
  },
  {
    path: '/statistik/:id',
    name: 'statistik_query',
    component: () =>
      import(/* webpackChunkName: "offers" */ '../views/statistics/Query.vue'),
  },
  {
    path: '/provision',
    name: 'comission',
    supervisor: true,
    component: () =>
      import(/* webpackChunkName: "offers" */ '../views/Comission.vue'),
  },
  {
    path: '/logs',
    name: 'logs',
    elevated: true,
    component: () =>
      import(/* webpackChunkName: "logs" */ '../views/Pending.vue'),
  },
  {
    path: '/jobs',
    name: 'jobs',
    elevated: true,
    component: () =>
      import(/* webpackChunkName: "jobs" */ '../views/Pending.vue'),
  },
  {
    path: '/content',
    name: 'content-overview',
    editor: true,
    component: () =>
      import(/* webpackChunkName: "content" */ '../views/content/Overview.vue'),
  },
  {
    path: '/content/pages',
    name: 'content-pages',
    editor: true,
    component: () =>
      import(/* webpackChunkName: "content" */ '../views/content/Pages.vue'),
  },
  {
    path: '/content/home',
    name: 'content-home',
    editor: true,
    component: () =>
      import(/* webpackChunkName: "content" */ '../views/content/HomePage.vue'),
  },
  {
    path: '/content/menus',
    name: 'content-menu',
    editor: true,
    component: () =>
      import(/* webpackChunkName: "content" */ '../views/content/SiteMenu.vue'),
  },
  {
    path: '/admin/create',
    name: 'create-user',
    supervisor: true,
    component: () =>
      import(
        /* webpackChunkName: "create-user" */ '../views/admin/CreateUser.vue'
      ),
  },
  {
    path: '/admin/user-management',
    name: 'user-managment',
    elevated: true,
    component: () =>
      import(
        /* webpackChunkName: "user-management" */ '../views/admin/UserManagement.vue'
      ),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
router.beforeEach((to, from, next) => {
  if (to.name !== 'login') {
    if (!store.getters.authenticated) {
      next({name: 'login'})
    } else {
      if (to.elevated && !store.getters.elevated) {
        next(false)
      } else if (to.supervisor && !store.getters.supervisor) {
        next(false)
      } else if (to.editor && !store.getters.isEditor) {
        next(false)
      } else {
        next()
      }
    }
  } else {
    next()
  }
})
store.dispatch('loadAccesTokens')
export default router
